import { NgClickOutsideDirective } from 'ng-click-outside2';
import { PhoneFilterModule } from './phone-filter/phone-filter.module';
// ---- Angular ----
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// ---- ng libraries ----
import { TranslateModule } from '@ngx-translate/core';

// ---- Kendo UI ----
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule } from '@progress/kendo-angular-grid';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ButtonsModule, ButtonGroupModule, ButtonModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { UploadModule } from '@progress/kendo-angular-upload';

// ---- ngx-permissions ----
import { NgxPermissionsModule } from 'ngx-permissions';

// ---- Channels
import { TimelineModule } from './timeline/timeline.module';
import { ResizedModule } from './resize-event/resized.module';
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { NotFoundModule } from './not-found/not-found.module';
import { AdvancedModeModule } from './advanced-mode/advanced-mode.module';
import { ListModeModule } from './list-mode/list-mode.module';
import { SaveFilterModule } from './save-filter/save-filter/save-filter.module';
import { PipesModule } from './pipes/pipes.module';
import { DropDownListFilterModule } from './dropdownlist/dropdownlist.module';
import { PreventClickModule } from './prevent-click/prevent-click.module';
import { QueryBuilderModule } from './query-builder/query-builder.module';
import { CollapsibleModule } from './collapsible/collapsible.module';
import { PatientHeaderModule } from './patient-header/patient-header.module';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { CommunityServiceInfoModule } from './community-service-info/community-service-info.module';
import { IconsModule } from '@progress/kendo-angular-icons';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    NgClickOutsideDirective,
    InputsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    DialogsModule,
    GridModule,
    PopupModule,
    ButtonModule,
    DropDownButtonModule,
    ButtonsModule,
    ButtonGroupModule,
    DateInputsModule,
    ChartsModule,
    TimelineModule,
    QueryBuilderModule,
    ResizedModule,
    BreadcrumbModule,
    UploadModule,
    NotFoundModule,
    AdvancedModeModule,
    ListModeModule,
    SaveFilterModule,
    PipesModule,
    DropDownListFilterModule,
    PhoneFilterModule,
    CollapsibleModule,
    PatientHeaderModule,
    NgxPermissionsModule.forRoot(),
    TooltipModule,
    CommunityServiceInfoModule,
    IconsModule
  ],
  providers: [],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    NgClickOutsideDirective,
    InputsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    DialogsModule,
    GridModule,
    PopupModule,
    ButtonsModule,
    ButtonGroupModule,
    DateInputsModule,
    ChartsModule,
    TimelineModule,
    QueryBuilderModule,
    ResizedModule,
    BreadcrumbModule,
    UploadModule,
    NgxPermissionsModule,
    NotFoundModule,
    AdvancedModeModule,
    ListModeModule,
    SaveFilterModule,
    PipesModule,
    DropDownListFilterModule,
    PreventClickModule,
    PhoneFilterModule,
    CollapsibleModule,
    PatientHeaderModule,
    TooltipModule,
    CommunityServiceInfoModule,
    IconsModule
  ]
})
export class SharedModule { }
